import { render, staticRenderFns } from "./Planta.vue?vue&type=template&id=ed51236c"
import script from "./Planta.vue?vue&type=script&lang=js"
export * from "./Planta.vue?vue&type=script&lang=js"
import style0 from "./Planta.vue?vue&type=style&index=0&id=ed51236c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports